import { ref } from 'vue';

const theme = ref(localStorage.getItem('theme') || 'light');

const applyTheme = (newTheme) => {
  const root = document.documentElement;
  
  // Remove both classes first
  root.classList.remove('dark-mode', 'light-mode');
  
  if (newTheme === 'dark') {
    root.classList.add('dark-mode');
  } else {
    root.classList.add('light-mode');
  }
  
  theme.value = newTheme;
  localStorage.setItem('theme', newTheme);
};

const toggleTheme = () => {
  const newTheme = theme.value === 'light' ? 'dark' : 'light';
  applyTheme(newTheme);
};

const setTheme = (newTheme) => {
  if (['light', 'dark'].includes(newTheme)) {
    applyTheme(newTheme);
  }
};

// Initialize theme immediately when module loads
if (typeof document !== 'undefined') {
  applyTheme(theme.value);
}

export function useTheme() {
  return {
    theme,
    toggleTheme,
    setTheme,
  };
}

